import React from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import PropTypes from "prop-types";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";

import { Chart } from "react-chartjs-2";
ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
);
import GraphSkeleton from "../../components/ui/Skeleton/GraphSkeleton";

const CustomerBarGraph = ({ dataCategories, dataReport, loading = false }) => {
  const data = {
    labels: dataCategories,
    datasets: [
      {
        type: "line",
        label: "Ingresos por Cliente",
        data: dataReport[1],
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgb(255, 99, 132)",
        yAxisID: "y1",
      },
      {
        type: "bar",
        label: "SMS por Cliente",
        data: dataReport[0],
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        yAxisID: "y",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: "SMS por Cliente",
      },
    },
    scales: {
      y: {
        type: "logarithmic",
        display: true,
        position: "left",
        min: 100,
        max: 40000000,
        afterBuildTicks: (axis) => {
          axis.ticks = [
            { value: 100 },
            { value: 1000 },
            { value: 10000 },
            { value: 100000 },
            { value: 1000000 },
            { value: 5000000 },
            { value: 10000000 },
            { value: 20000000 },
          ];
        },
        ticks: {
          callback: (value) => {
            const labels = {
              0: "0",
              100: "100",
              1000: "1k",
              10000: "10k",
              100000: "100k",
              1000000: "1M",
              5000000: "5M",
              10000000: "10M",
              20000000: "20M",
            };

            return labels[value] ?? "";
          },
        },
      },
      y1: {
        type: "linear",
        display: true,
        position: "right",
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };
  if (loading)
    return (
      <div className="w-full h-full bg-white rounded-lg px-4 py-2">
        <GraphSkeleton />
      </div>
    );
  return (
    <div className="w-full h-full bg-white rounded-lg px-4 py-2 mx-2 ">
      <Row>
        <Col xs={12} sm={6} md={12} lg={12} xl={12}>
          <div style={{ height: "500px" }}>
            <Chart type="bar" options={options} data={data} />
          </div>
        </Col>
      </Row>
    </div>
  );
};
CustomerBarGraph.propTypes = {
  dataCategories: PropTypes.array.isRequired,
  dataReport: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};
export default CustomerBarGraph;
